import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

const SafetyNotice = ({ compact = false, className = '' }) => {
  const baseClasses =
    'flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 text-amber-800';
  const sizeClasses = compact
    ? 'p-3 text-xs leading-relaxed md:text-sm'
    : 'p-4 text-sm md:text-base leading-relaxed';
  const iconClasses = `${compact ? 'w-5 h-5' : 'w-6 h-6'} mt-0.5 flex-shrink-0`;

  return (
    <div className={`${baseClasses} ${sizeClasses} ${className}`.trim()}>
      <AlertTriangle className={iconClasses} />
      <p>
        Start slowly, focus on smooth form, and follow the{' '}
        <Link
          to="/safety"
          className="font-semibold underline decoration-amber-500 underline-offset-2 hover:text-amber-900"
        >
          ElderFit safety guidelines
        </Link>
        . Pause immediately if you feel dizzy, off balance, or uncomfortable, and only increase intensity
        when you feel steady.
      </p>
    </div>
  );
};

export default SafetyNotice;

